module.exports = __webpack_public_path__ + "img/main_banner.f832182c.png";